import React from 'react';
import { Box, Container, Typography, Link, useTheme } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = ({ branding = {} }) => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 4,
        borderTop: `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box
              sx={{
                width: 30, height: 30, borderRadius: '50%',
                bgcolor: theme.palette.primary.main,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <LocationOnIcon sx={{ color: '#fff', fontSize: 16 }} />
            </Box>
          </Box>

          {/* Links */}
          <Box sx={{ display: 'flex', gap: 3 }}>
            {['Contact Us', 'Privacy Policy', 'Terms of Service'].map((lnk) => (
              <Link
                key={lnk}
                href="#"
                underline="none"
                sx={{ color: 'text.secondary', fontSize: 13, '&:hover': { color: 'primary.main' } }}
              >
                {lnk}
              </Link>
            ))}
          </Box>

          <Typography variant="caption" color="text.disabled">
            © {new Date().getFullYear()} All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
